import axios from 'axios';

const baseURL = import.meta.env.VITE_BACKEND_BASE_URL;
export const Backend_Base_Url = 'https://endureva.cloud/backend-services-demo-setup';
// Create axios instance
const apiPath = axios.create({
    // baseURL: baseURL,
    // baseURL: 'https://stp-services-dev.reserveyourvenue.com',
    // baseURL: 'https://goatankerbooking.com/backend-services'
    // baseURL: 'http://localhost:3002'
    // baseURL: 'https://solutions.endurevadev.online'
    // baseURL: 'https://endureva.cloud/backend-services-goa-tanker'
        baseURL: Backend_Base_Url
    
});

// ---- Token Refresh Control ---- //
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

// Request interceptor to add token
apiPath.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ---- Response Interceptor ---- //
apiPath.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // ---- If unauthorized (401 or 403) ---- //
    if (
      (error.status === 401 || error.status === 403) &&
      !originalRequest._retry
    ) {
      // ---- Wait if refresh already in progress ---- //
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return apiPath(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) throw new Error('No refresh token found');

        // ---- Call refresh token API ---- //
        const response = await axios.post(`${baseURL}/api/v1.0/auth/refresh-token`, {
          refreshToken: refreshToken,
        });

        if (response.status === 200) {
          const newToken = response.data?.data?.token;
          const newRefreshToken = response.data?.data?.refreshToken;

          if (newToken) {
            // ✅ Store new tokens
            localStorage.setItem('token', newToken);
            if (newRefreshToken) localStorage.setItem('refreshToken', newRefreshToken);

            // ✅ Continue queued requests
            processQueue(null, newToken);

            // ✅ Retry the original request automatically
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return apiPath(originalRequest);
          }
        }

        throw new Error('Invalid refresh response');
      } catch (refreshError) {
        // ---- Handle refresh failure ---- //
        if (
          refreshError.status === 401 ||
          refreshError.status === 403
        ) {
          console.warn('Session expired. Redirecting to login...');
          localStorage.clear();
          setTimeout(() => (window.location.href = '/login'), 1000);
        }

        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default apiPath;
